import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Mail, Loader2, CheckCircle2, ArrowLeft, KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/password-reset/request", { email: email.trim().toLowerCase() });
      setSent(true);
      toast.success("E-mail de redefinição enviado!");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-[400px]">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="h-9 w-9 rounded-md bg-[#0055FF] text-white flex items-center justify-center font-bold">Z</div>
          <div className="text-[15px] font-semibold tracking-tight">Portal Zemo</div>
        </div>

        {sent ? (
          <div className="text-center" data-testid="forgot-password-sent">
            <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto mb-4" />
            <h1 className="text-xl font-semibold text-zinc-900">Verifique seu e-mail</h1>
            <p className="mt-2 text-sm text-zinc-500">
              Se <strong>{email}</strong> estiver cadastrado, você receberá um link para
              redefinir sua senha. O link expira em 30 minutos.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1.5 text-sm text-[#0055FF] hover:underline font-medium">
              <ArrowLeft className="h-3.5 w-3.5" /> Voltar ao login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 text-center">
              Esqueceu sua senha?
            </h1>
            <p className="mt-2 text-sm text-zinc-500 text-center">
              Digite seu e-mail e enviaremos um link para redefinir sua senha.
            </p>

            <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="forgot-password-form">
              <div className="space-y-1.5">
                <Label htmlFor="reset-email">E-mail</Label>
                <Input
                  id="reset-email" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@empresa.com.br" required
                  className="h-11" data-testid="forgot-email-input"
                />
              </div>
              <Button type="submit" disabled={submitting}
                className="w-full h-11 bg-[#0055FF] hover:bg-[#0044CC] text-white font-semibold"
                data-testid="forgot-submit">
                {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Mail className="h-4 w-4 mr-2" /> Enviar link de redefinição</>}
              </Button>
            </form>

            <div className="mt-4 text-center">
              <Link to="/login" className="text-sm text-zinc-500 hover:text-zinc-700 flex items-center justify-center gap-1.5">
                <ArrowLeft className="h-3.5 w-3.5" /> Voltar ao login
              </Link>
            </div>
          </>
        )}

        <div className="mt-8 flex items-center gap-2 text-[11px] text-zinc-400 justify-center">
          <KeyRound className="h-3 w-3" />
          <span>Link seguro via AWS SES</span>
        </div>
      </div>
    </div>
  );
}
